"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTheme = void 0;
var core_1 = require("@material-ui/core");
var StyledComponentsTheme_1 = require("./StyledComponentsTheme");
var extendedOverrides = {
    MuiTabPanel: {
        root: {
            padding: 'unset',
            flex: 1,
        },
    },
};
exports.MuiTheme = core_1.createMuiTheme({
    overrides: __assign({ MuiSelect: {
            select: {
                paddingLeft: 16,
                padding: '12px 10px',
                fontSize: 14,
                background: '#fff',
                border: '1px solid #000',
                height: 48,
                borderRadius: 4,
                '&$disabled': {
                    borderColor: 'rgba(9, 9, 9, 0.3)',
                    backgroundColor: 'rgba(9, 9, 9, 0.05)',
                },
                '&:focus': {
                    borderRadius: 4,
                    backgroundColor: 'transparent',
                },
            },
        }, MuiTooltip: {
            tooltip: {
                backgroundColor: StyledComponentsTheme_1.THEME.colors.darkBlue,
                color: 'white',
                maxWidth: 220,
                boxShadow: '0px 4px 14px rgba(12, 43, 84, 0.2)',
                fontSize: 14,
                fontWeight: 'normal',
                lineHeight: '17px',
            },
            arrow: {
                color: StyledComponentsTheme_1.THEME.colors.darkBlue,
            },
        }, MuiSwitch: {
            root: {
                width: 46,
                height: 22,
                padding: 0,
                overflow: 'visible',
            },
            switchBase: {
                padding: 3,
                '&$checked': {
                    transform: 'translateX(22px)',
                    '& + $track': {
                        opacity: 1,
                    },
                },
            },
            thumb: {
                width: 18,
                height: 18,
                boxShadow: 'unset',
            },
            track: {
                borderRadius: 33,
                opacity: 1,
            },
            checked: {},
            colorPrimary: {
                color: StyledComponentsTheme_1.THEME.colors.basic.Black,
                '&$checked': {
                    color: StyledComponentsTheme_1.THEME.colors.basic.Black,
                    '& + $track': {
                        backgroundColor: StyledComponentsTheme_1.THEME.colors.primary.IceterineYellow100,
                    },
                    '&$disabled': {
                        '& + $track': {
                            backgroundColor: StyledComponentsTheme_1.THEME.colors.primary.IceterineYellow50,
                            border: "1px solid " + StyledComponentsTheme_1.THEME.colors.basic.Grey20,
                        },
                    },
                },
                '&$disabled': {
                    color: StyledComponentsTheme_1.THEME.colors.basic.Grey20,
                    '& + $track': {
                        opacity: 0.5,
                        backgroundColor: StyledComponentsTheme_1.THEME.colors.basic.Grey05,
                        border: "1px solid " + StyledComponentsTheme_1.THEME.colors.basic.Grey20,
                    },
                },
                '& + $track': {
                    backgroundColor: StyledComponentsTheme_1.THEME.colors.basic.Grey05,
                    border: '1px solid #000',
                },
            },
        }, MuiButton: {
            root: {
                textTransform: 'inherit',
            },
        }, MuiCheckbox: {
            root: {
                borderRadius: 4,
                '&$disabled': {
                    backgroundColor: StyledComponentsTheme_1.THEME.colors.basic.Grey05,
                },
            },
            colorPrimary: {
                '&$checked': {
                    color: StyledComponentsTheme_1.THEME.colors.basic.Black,
                },
            },
            colorSecondary: {
                '&$checked': {
                    color: StyledComponentsTheme_1.THEME.colors.basic.Black,
                },
            },
        }, MuiMenu: {
            paper: {
                border: "1px solid " + StyledComponentsTheme_1.THEME.colors.basic.Black,
                borderRadius: 4,
                boxShadow: '4px 4px 0px 0px rgba(0, 0, 0, 0.2)',
            },
            list: {
                padding: 8,
            },
        }, MuiRadio: {
            root: {
                padding: 0,
                paddingRight: 16,
            },
            colorSecondary: {
                '&$checked': {
                    color: StyledComponentsTheme_1.THEME.colors.basic.Black,
                },
            },
        }, MuiFormControlLabel: {
            root: {
                display: 'flex',
                alignItems: 'flex-start',
                marginLeft: 0,
                marginRight: 0,
                marginBottom: 24,
            },
        }, MuiTabs: {
            root: {
                height: '100%',
            },
            indicator: {
                left: 0,
                width: 4,
                height: 4,
                background: StyledComponentsTheme_1.THEME.colors.basic.Black,
            },
            flexContainer: {
                height: '100%',
            },
        }, MuiTab: {
            root: {
                '&$selected': {
                    fontWeight: 'bolder',
                },
            },
            textColorInherit: {
                opacity: 1,
            },
            wrapper: {
                flexDirection: 'row',
            },
        }, MuiSlider: {
            root: {
                color: StyledComponentsTheme_1.THEME.colors.secondary.Xiketic100,
                height: 6,
            },
            thumb: {
                height: 20,
                width: 20,
                backgroundColor: '#fff',
                border: '2px solid currentColor',
                marginTop: -7,
                marginLeft: -12,
                '&:focus, &:hover, &$active': {
                    boxShadow: 'inherit',
                },
            },
            active: {},
            valueLabel: {
                left: 'calc(-50% + 4px)',
            },
            track: {
                height: 6,
                borderRadius: 4,
            },
            rail: {
                height: 6,
                borderRadius: 4,
            },
        }, MuiBadge: {
            dot: {
                height: 12,
                width: 12,
                minWidth: 12,
                borderRadius: '50%',
                fontSize: '0.6rem',
            },
            colorPrimary: {
                backgroundColor: StyledComponentsTheme_1.THEME.colors.basic.Black,
                color: '#fff',
            },
            colorSecondary: {
                backgroundColor: StyledComponentsTheme_1.THEME.colors.danger.Red100,
                color: '#fff',
            },
            badge: {
                fontSize: '0.6rem',
                height: 15,
                width: 15,
                minWidth: 15,
            },
            anchorOriginTopRightRectangle: {
                top: '-5px',
                right: '-5px',
            },
            anchorOriginTopLeftRectangle: {
                left: '-3px',
            },
        }, MuiChip: {
            root: {
                boxShadow: '1px 1px 0 0 #000',
                backgroundColor: StyledComponentsTheme_1.THEME.colors.primary.IceterineYellow100,
                fontWeight: 'bolder',
                height: 'unset',
                border: '1px solid #000',
                opcaity: 0.8,
            },
        }, MuiPopover: {
            paper: {
                borderRadius: 4,
                border: '1px solid #000',
                boxShadow: '4px 4px 0px 0px rgba(0, 0, 0, 0.2)',
            },
        }, MuiBottomNavigationAction: {
            root: {
                transition: 'transform 150ms linear',
            },
            label: {
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: 12,
                lineHeight: '15px',
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                marginTop: 4,
                color: '#000000',
                position: 'relative',
                '&$selected': {
                    fontWeight: 900,
                },
            },
        } }, extendedOverrides),
});
//# sourceMappingURL=MuiTheme.js.map